import * as angular from "angular";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ProductDataProvider } from "../../data-provider/product.dp";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";

let PurchaseSeatsDialogComponent = {
    selector: "purchaseSeatsDialog",
    templateUrl:
        "/angular/components/product/purchase-seats-dialog.component.html",
    bindings: {
        numSeats: "=",
    },
    controller: class PurchaseSeatsDialog {
        // * bindings for typescript compiler *
        public numSeats: number;
        // ************************************

        private productDataProvider: ProductDataProvider;
        private limitDataProvider: LimitDataProvider;
        private $scope: any;
        private $window: any;
        private quantity: number;
        private activeCampaign: Campaign;
        private products: any[];
        private product: any;
        private recurring: number;
        private invoice: any;
        private saving: boolean;
        private dialog: DialogUtils;

        constructor(
            $scope: any,
            $window: any,
            ProductDataProvider: ProductDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            LimitDataProvider: LimitDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.dialog = DialogUtils;
            this.productDataProvider = ProductDataProvider;
            this.limitDataProvider = LimitDataProvider;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
        }

        $onInit() {
            this.quantity = this.numSeats;
            this.productDataProvider.all().then((products: object[]) => {
                this.product = this.productDataProvider.getUserLicenseProduct(
                    this.activeCampaign,
                    products
                );

                this.recurring = this.product.price * this.quantity;
                this.productDataProvider
                    .previewInvoice(this.product.stripeid, this.quantity)
                    .then((data: object) => {
                        this.invoice = data;
                    });
            });
        }

        openUpgradePlanDialog(conversionType: string, ev: object): void {
            this.dialog
                .show({
                    component: "vc-upgrade-plan-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: conversionType,
                        type: "dialog",
                        charge: false,
                    },
                    size: "x-large",
                    style: "background: #f6f6f6",
                })
                .then(() => this.$window.reload());
        }

        confirm(): void {
            this.saving = true;
            this.productDataProvider
                .changeQuantity(this.product, this.quantity)
                .then(() => {
                    this.limitDataProvider.getLimits();
                    this.dialog.hide();
                });
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("product")
    .component(
        PurchaseSeatsDialogComponent.selector,
        PurchaseSeatsDialogComponent
    );
